module.exports = __webpack_public_path__ + "fonts/iconfont.8586795e.eot";